export enum ConversionRateTypes {
  Actual = 'actual',
  Historical = 'historical',
}

export const CONVERSION_RATE_TYPES_VALUES = [
  { id: ConversionRateTypes.Actual, label: 'Актуальный' },
  { id: ConversionRateTypes.Historical, label: 'Исторический' },
];
